import { api, showErrorNotification, showSuccessNotification } from '@med-fe/util';
import { call, put } from 'redux-saga/effects';
import {
  fetchCallForwarding,
  fetchCallForwardingSuccess,
  fetchCallForwardingFailed,
  cancelCallForwardingSuccess,
  cancelCallForwardingFailed,
} from './actions';

export function* fetchCallForwardingWorker({ payload }): Generator {
  try {
    const { active, page, pageSize, sourceOfficeNumber, destinationOfficeNumber, startDate, endDate, status } =
      payload || {};

    const queryParams = new URLSearchParams();

    if (active !== undefined) {
      queryParams.set('active', String(active));
    }

    if (page !== undefined) {
      queryParams.set('page', String(page));
    }

    if (pageSize !== undefined) {
      queryParams.set('pageSize', String(pageSize));
    }

    if (sourceOfficeNumber) {
      queryParams.set('sourceOfficeNumber', sourceOfficeNumber);
    }

    if (destinationOfficeNumber) {
      queryParams.set('destinationOfficeNumber', destinationOfficeNumber);
    }

    if (startDate) {
      queryParams.set('startDate', startDate);
    }

    if (endDate) {
      queryParams.set('endDate', endDate);
    }

    if (Array.isArray(status) && status.length) {
      queryParams.set('status', status.join(','));
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `/locations/call-forwarding-requests?${queryString}`
      : `/locations/call-forwarding-requests`;

    const data: any = yield call(api.get, url);
    yield put(fetchCallForwardingSuccess(data));
  } catch (e) {
    yield put(fetchCallForwardingFailed(e));
    showErrorNotification();
  }
}

export function* cancelCallForwardingWorker({ payload }): Generator {
  try {
    const { requestId, cancellationReason, searchPayload } = payload || {};
    yield call(api.put, `/locations/call-forwarding-requests/${requestId}/cancel`, { cancellationReason });
    yield put(cancelCallForwardingSuccess());
    showSuccessNotification('Call forwarding request cancelled successfully');
    // Refresh the list after cancellation
    yield put(fetchCallForwarding(searchPayload || {}));
  } catch (e) {
    yield put(cancelCallForwardingFailed(e));
    showErrorNotification('Failed to cancel call forwarding request');
  }
}
